module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAQAAAD9CzEMAAAAg0lEQVR4Ae3QvQ2CMRRD0dtRMk74W4zOa7HBNw6EAYKQqHgSDTFC4Js6x9IjpZQ+3YGjl78ykJe/P3n5MhB+H/53+f61/JoTzckvDM40D79ieXy90Dy3F+PFxO5Nvkxs5vN1YjZfJrbz+Toxly8T3cA/TVj4OiEMycSXCWFMiL8upXQDujO26ouV5ZIAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/components/Checkbox/ic_done_black_24dp_2x.png
// module id = 85
// module chunks = 0